module.exports = __webpack_public_path__ + "static/img/product-banner.fd38f0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product-banner.jpg
// module id = 7OFQ
// module chunks = 1